var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"hover":""}},[_c('v-chip',{staticClass:"caption ma-1",attrs:{"label":"","outlined":""}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-star-circle")]),_vm._v(" "+_vm._s(_vm.item.title)+" ")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }